import request from '../request';

import { url } from './config';

const api = {
    getSchema() {
        return request
            .get(`${url}/schema`)
            .then((res) => res.data)
            .catch((error) => {
                throw error;
            });
    },
    get(params) {
        return request
            .get(`${url}`, { params })
            .then((res) => res.data)
            .catch((error) => {
                throw error;
            });
    },
    getById(id, params) {
        return request
            .get(`${url}/${id}`, { params })
            .then((res) => res.data)
            .catch((error) => {
                throw error;
            });
    },
    post(body) {
        return request
            .post(`${url}`, body)
            .then((res) => res.data)
            .catch((error) => {
                throw error;
            });
    },
    put(body) {
        return request
            .put(`${url}`, body)
            .then((res) => res.data)
            .catch((error) => {
                throw error;
            });
    },
    remove(id) {
        return request
            .delete(`${url}/${id}`)
            .then((res) => res.data)
            .catch((error) => {
                throw error;
            });
    }
};

export default api;
